import * as THREE from 'three';

/** Geometrías compartidas (patrón three.js manual — optimize lots of objects). */
const cache = new Map<string, THREE.BufferGeometry>();

function geo(key: string, factory: () => THREE.BufferGeometry): THREE.BufferGeometry {
  let g = cache.get(key);
  if (!g) {
    g = factory();
    cache.set(key, g);
  }
  return g;
}

export const SharedGeometries = {
  chairSeat: () => geo('chairSeat', () => new THREE.BoxGeometry(0.4, 0.08, 0.4)),
  chairBack: () => geo('chairBack', () => new THREE.BoxGeometry(0.4, 0.48, 0.07)),
  tableLeg: () => geo('tableLeg', () => new THREE.CylinderGeometry(0.14, 0.2, 0.78, 16)),
  pot: () => geo('pot', () => new THREE.CylinderGeometry(0.38, 0.45, 0.55, 14)),
  bush: () => geo('bush', () => new THREE.SphereGeometry(0.62, 10, 8)),
  contactShadow: () => geo('contactShadow', () => new THREE.CircleGeometry(0.35, 16)),
};
